module.exports = __webpack_public_path__ + "static/media/freshclinics_portfolio_2x.f2d8e9cc.jpeg";